module.exports = __webpack_public_path__ + "img/unknown.6fc49b5e.svg";